import { useCallback } from "react";

import { QuestionForMain } from "@/components/features/_layouts/island/main/question";
import type { SiteControllerSettingAirHostFormModel } from "@/components/features/settings/site-controller/model/air-host/type";
import type { SiteControllerSettingAirHostFormModelMethodsType } from "@/components/features/settings/site-controller/model/air-host/use-case/use-create-model/methods";

import { InputTextFieldNew } from "@/components/ui/form/fields-new/input-field/input-text";

import type { ChangeEvent } from "react";

type Props = {
	airHostPartnerID: SiteControllerSettingAirHostFormModel["ViewModel"]["airHostSettings"]["airHostPartnerID"];
	onSetAirHostPartnerID: SiteControllerSettingAirHostFormModelMethodsType["onSetAirHostPartnerID"];
};

export const SettingsSiteControllerAirHostPartnerID = ({ airHostPartnerID, onSetAirHostPartnerID }: Props) => {
	const handleChangePartnerID = useCallback(
		(event: ChangeEvent<HTMLInputElement>) => {
			onSetAirHostPartnerID(event.target.value);
		},
		[onSetAirHostPartnerID],
	);

	return (
		<QuestionForMain
			required={true}
			title={"パートナーID（X-AH-Partner）"}
			inputChildren={
				<InputTextFieldNew
					className="w-2/3 lg:w-1/2"
					value={airHostPartnerID.value}
					errorMessage={airHostPartnerID.error}
					onChange={handleChangePartnerID}
					autoComplete="off"
				/>
			}
		/>
	);
};

SettingsSiteControllerAirHostPartnerID.displayName = "SettingsSiteControllerAirHostPartnerID";
